import { useState } from 'react';
import InitFilters from './constants/InitFiltering';
import { useCurrencyUnit} from 'hooks';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [dataDialog, setDataDialog] = useState(null);
  const [filterParams, setFilterParams] = useState(null);
  const [activeDetailID, setActiveDetailID] = useState(null);
  const [counter, setCounter] = useState(0);
  const currencyText = useCurrencyUnit()
  const [filters, setFilters] = useState(InitFilters(currencyText));
  const [emptyLabel, setEmptyLabel] = useState('داده‌ای یافت نشد!');
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  return {
    dataDialog, setDataDialog,
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    activeDetailID,
    setActiveDetailID,
    counter,
    setCounter,
    filters,
    setFilters,
    emptyLabel,
    setEmptyLabel,
    page, setPage,
    showDialog, setShowDialog
  };
};

export default useCustomHook;
